import styled from 'styled-components'

const Subheading = styled.h4`
  color: ${({ theme }) => theme.colors.stone};
  font-size: 12px;
  font-weight: 600;
  margin: 0;
`

export default Subheading
